$(function () {
    $('.site_banner__search_form #product-name').select2({
        placeholder: 'Select an option'
    });
})